const App = {
  SetBackground: () => {
    $("[setBackground]").each(function () {
      var background = $(this).attr("setBackground");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-size": "cover",
        "background-position": "center center",
      });
    });
    $("[setBackgroundRepeat]").each(function () {
      var background = $(this).attr("setBackgroundRepeat");
      $(this).css({
        "background-image": "url(" + background + ")",
        "background-repeat": "repeat",
      });
    });
  },
  EqualHeightElement: (el) => {
    let height = 0;
    let thisHeight = 0;
    $(el).each(function () {
      thisHeight = $(this).height();
      if (thisHeight > height) {
        height = thisHeight;
      }
    });
    $(el).height(height);
  },
  ScrollTo: (y) => {
    $("html, body").animate(
      {
        scrollTop: y,
      },
      1000
    );
  },
  Init: () => {
    App.ScrollTo();
    App.SetBackground();
  },
};

function InitSlider() {
  var heroBanner = new Swiper(".hero-banner .swiper-container", {
    speed: 1500,
    effect: "fade",
    fadeEffect: {
      crossFade: true,
    },
    navigation: {
      clickable: !0,
      nextEl: ".hero-banner .swiper-next",
      prevEl: ".hero-banner .swiper-prev",
    },
    pagination: {
      el: ".hero-banner .swiper-pagination",
      clickable: !0,
      type: "bullets",
    },
  });

  var otherProductSlide = new Swiper(".other-products .swiper-container", {
    slidesPerView: 4,
    spaceBetween: 40,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
  });

  var ProductSlide = new Swiper(".products-slide .swiper-container", {
    slidesPerView: 4,
    spaceBetween: 40,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
  });
  var customerSlide = new Swiper(".customer .swiper-container", {
    slidesPerView: 7,
    spaceBetween: 50,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      1200: {
        slidesPerView: 6,
        spaceBetween: 50,
      },
      992: {
        slidesPerView: 4,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 40,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 30,
      },
    },
  });
  var whyChooseUsSlide = new Swiper(".why-choose-us .swiper-container", {
    slidesPerView: 4,
    spaceBetween: 40,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      768: {
        slidesPerView: 2,
        spaceBetween: 20,
      },
    },
  });
  var awardSlide = new Swiper(".award-certifications .swiper-container", {
    slidesPerView: 4,
    spaceBetween: 100,
    autoplay: {
      delay: 5000,
    },
    breakpoints: {
      992: {
        slidesPerView: 3,
      },
      576: {
        slidesPerView: 2,
        spaceBetween: 70,
      },
    },
  });

  if ($(".products-details").length) {
    var galleryThumbs = new Swiper(".products-details .swiper-container", {
      spaceBetween: 20,
      slidesPerView: 1,
      watchSlidesVisibility: true,
      watchSlidesProgress: true,
      navigation: {
        clickable: !0,
        nextEl: ".products-details .swiper-next",
        prevEl: ".products-details .swiper-prev",
      },
    });
  }
}

function Headers() {
  $(document).on("click", ".toggle-btn", function () {
    $(this).toggleClass("active");
    $(".mobile-nav-inner").toggleClass("active");
    $(".back-drop").toggleClass("active");
  });
  $(document).on("click", ".back-drop", function () {
    $(this).removeClass("active");
    $(".mobile-nav-inner").removeClass("active");
    $(".toggle-btn").remove("active");
  });
  $(document).on(
    "click",
    ".mobile-nav-inner li.has-dropdown > .icon-dropdown",
    function () {
      if ($(this).hasClass("active")) {
        $(this).removeClass("active");
        $(this).parents(".has-dropdown").removeClass("active");
        $(this).next().slideUp();
      } else {
        $(".header .nav-sub").slideUp();
        $(".icon-dropdown").removeClass("active");
        $(".has-dropdown").removeClass("active");
        $(this).toggleClass("active").next().slideDown();
        $(this).parents(".has-dropdown").toggleClass("active");
      }
    }
  );
  $(window).on("resize", function () {
    $("header .mobile-nav-inner").removeClass("active");
    $("body").removeClass("overflow-hidden");
    $(".back-drop").removeClass("active");
    $(".toggle-btn").removeClass("active");
  });
  $(document).on("click", ".sidebar .head", function () {
    $(this).toggleClass("active");
    $(".sidebar .menu").slideToggle();
  });
}
//mapping
function mappings() {
  var moveNav = new MappingListener({
    selector: "header .menu",
    mobileWrapper: ".mobile-nav-inner",
    mobileMethod: "appendTo",
    desktopWrapper: "header .logo",
    desktopMethod: "insertAfter",
    breakpoint: 1025,
  }).watch();
}
function accordion() {
  if ($(".accordions").length) {
    $(".accordion-item.active").find(".accordion-content").show();
    $(".accordion-heading").on("click", function () {
      if (!$(this).parent().is(".active")) {
        $(this)
          .parent()
          .toggleClass("active")
          .children(".accordion-content")
          .slideToggle(500)
          .parent()
          .siblings(".active")
          .removeClass("active")
          .children(".accordion-content")
          .slideToggle(500);
      } else {
        $(this).parent().toggleClass("active");
        $(this).next().slideToggle(500);
      }
    });
  }
}

function jarallax() {
  $(".jarallax").jarallax({
    speed: 0.2,
    disableParallax: / iPad | iPhone | iPod | Android /,
    disableVideo: / iPad | iPhone | iPod | Android /,
  });
}

function myTabs() {
  $(".my-tabs").each(function () {
    var $this = $(this);
    $(".tabs-nav li:first").addClass("active");
    $this.find(".tab-content:first").show();
    $this.find(".tabs-nav li").click(function () {
      var corresponding = $(this).data("tab");
      $(".tab-content").hide();
      $(".tab-content." + corresponding).show();
      $(".tabs-nav li").removeClass("active");
      $(this).addClass("active");
    });
  });
}
function sidebarDropdown() {
  //mega menu
  // $(document).on("click", ".sidebar .sidebar-text", function () {
  //   if ($(this).hasClass("active")) {
  //     $(this).removeClass("active");
  //     $(this).siblings(".menu").slideUp(200);
  //   } else {
  //     $(".sidebar .sidebar-link").removeClass("active");
  //     $(this).addClass("active");
  //     $(".sidebar .menu").slideUp(200);
  //     $(this).siblings(".menu").slideDown(200);
  //   }
  // });
  $(document).on("click", ".mb-filter", function () {
    $(this).toggleClass("active");
    $(".sidebar").slideToggle();
  });
}
function fixedNav() {
  var nav = $(".header");
  if (nav.length) {
    $(window).on("load scroll", function () {
      if ($(window).scrollTop() > 100) {
        nav.addClass("fixed");
      } else {
        nav.removeClass("fixed");
      }
    });
  }
}
function selectUi() {
  $(".dropdown").on("click", ".dropdown-select", function () {
    if ($(this).parents(".dropdown").hasClass("open")) {
      $(this).parents(".dropdown").removeClass("open");
      $(this).siblings(".dropdown-list").hide();
    } else {
      $(".dropdown").removeClass("open");
      $(this).parents(".dropdown").addClass("open");
      $(".dropdown-list").hide();
      $(this).siblings(".dropdown-list").show();
    }
  });
  var allOptions = $(".dropdown-list").children(".dropdown-item");
  $(".dropdown-list").on("click", ".dropdown-item", function () {
    allOptions.removeClass("selected");
    $(this).addClass("selected");
    $(this)
      .parents(".dropdown")
      .find(".dropdown-selected")
      .html($(this).html())
      .css("color", "#000");
    $(this).parents(".dropdown-list").toggle();
    $(this).parents(".dropdown").toggleClass("open");
    $("input#inputInit").val($(this).data("val"));
  });
  var $menu = $(".dropdown");

  $(document).mouseup(function (e) {
    if (!$menu.is(e.target) && $menu.has(e.target).length === 0) {
      $menu.removeClass("open");
      $menu.find(".dropdown-list").hide();
    }
  });
}

function adjustProductAmount() {
  $(".plus").click(function () {
    $(this)
      .parents(".amount")
      .find(".input")
      .val(+$(this).parents(".amount").find(".input").val() + 1);
    $(".woocommerce-cart-form .update-cart.btn").removeAttr("disabled");
  });
  $(".minus").click(function () {
    if ($(this).parents(".amount").find(".input").val() > 1) {
      if ($(this).parents(".amount").find(".input").val() > 1)
        $(this)
          .parents(".amount")
          .find(".input")
          .val(+$(this).parents(".amount").find(".input").val() - 1);
    }
  });
}
function checkWidth() {
  var $window = $(window);
  var windowsize = $window.width();
  if (windowsize >= 1200) {
    $(".header").find(".nav-sub").removeAttr("style");
  }
  if (windowsize >= 768) {
    $(".sidebar").removeAttr("style");
  }
  $(".products-slide").each(function () {
    var height = $(this).find(".box-img").outerHeight();
    var btnHeight = $(this).find(".swiper-next").outerHeight();
    $(this)
      .find(".swiper-next,.swiper-prev")
      .css("top", height / 2 - btnHeight / 2);
  });
}
function checkboxForm() {
  $(".shipping-info .custom-checkbox input").click(function () {
    if ($(this).is(":checked")) {
      $(this).parents(".shipping-info").find(".another-address").show();
    } else {
      $(this).parents(".shipping-info").find(".another-address").hide();
    }
  });
}
function changeContent() {
  $(".change-content").each(function () {
    var $this = $(this);
    $(".box-item .item:first").addClass("active");
    $this.find(".box-content:first").show();
    // $(".previous").hide();
    $this.find(".item").each(function () {
      var corresponding = $(this).data("content");
      $(this).hover(function () {
        $(".change-content .box-content").hide();
        $(".box-content." + corresponding).show();
        $(".change-content .item").removeClass("active");
        $(this).addClass("active");
      });
    });
  });
}

function rangePrice() {
  $("#price-range").slider({
    range: true,
    min: 0,
    max: 200000,
    values: [0, 200000],
    slide: function (event, ui) {
      $("#priceRange").val("$" + ui.values[0] + " - $" + ui.values[1]);
    },
  });
  $("#priceRange").val(
    "$" +
      $("#price-range").slider("values", 0) +
      " - $" +
      $("#price-range").slider("values", 1)
  );
}
$(window).resize(checkWidth).trigger("resize");
$(document).ready(function () {
  App.Init();
  InitSlider();
  Headers();
  fixedNav();
  mappings();
  checkboxForm();
  rangePrice();
  selectUi();
  accordion();
  changeContent();
  jarallax();
  adjustProductAmount();
  sidebarDropdown();
  myTabs();
  checkWidth();
});
